import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/views/NotFound.vue";
import MainLayout from "@/layout/MainLayout.vue";
import SubLayout from "@/layout/SubLayout.vue";
import LearnLayout from "@/layout/LearnLayout.vue";
import store from "../store";
import { MessageBox } from "element-ui";

Vue.prototype.$alert = MessageBox.alert;

const router = new VueRouter({
  mode: "history",
  base: "",
  routes: [
    {
      name: "Main",
      path: "/",
      component: () => import("@/views/Main.vue"),
    },
    {
      name: "main",
      path: "/usr/main",
      meta: { layout: MainLayout },
      component: () => import("@/views/Main.vue"),
    },
    {
      name: "crse",
      path: "/usr/crse",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/Crse.vue"),
    },
    {
      name: "crseLaw",
      path: "/usr/crse/law",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/CrseLaw.vue"),
    },
    {
      name: "crseList",
      path: "/usr/crse/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/Crse.vue"),
    },
    {
      name: "enrollIntro",
      path: "/usr/enroll/intro/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/EnrollIntro.vue"),
    },
    {
      name: "enrollList",
      path: "/usr/enroll/list/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/Enroll.vue"),
    },
    {
      name: "enrollForm1",
      path: "/usr/enroll/step1/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm1.vue"),
    },
    {
      name: "enrollForm2",
      path: "/usr/enroll/step2/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm2.vue"),
    },
    {
      name: "enrollPayForm",
      path: "/usr/enroll/pay/form/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollPayForm.vue"),
    },
    {
      name: "enrollPayView",
      path: "/usr/enroll/pay/view/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollPayView.vue"),
    },
    {
      name: "myClassList",
      path: "/usr/myclass",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/MyClass.vue"),
    },
    {
      name: "certList",
      path: "/usr/myclass/cert",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/CertList.vue"),
    },
    {
      name: "enrollChangeCeoList",
      path: "/usr/enroll/change/ceo",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/enroll/EnrollChangeCeoList.vue"),
    },
    {
      name: "agentList",
      path: "/usr/myclass/agent",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/AgentList.vue"),
    },
    {
      name: "receiptList",
      path: "/usr/myclass/receipt",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/ReceiptList.vue"),
    },
    {
      name: "learnMain",
      path: "/usr/learn/main/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnMain.vue"),
    },
    {
      name: "learnLesson",
      path: "/usr/learn/lesson/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnLesson.vue"),
    },
    {
      name: "learnLessonView",
      path: "/usr/learn/lesson/:enrollNo/:lessonSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnLessonView.vue"),
    },
    {
      name: "learnExam",
      path: "/usr/learn/exam/list/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamList.vue"),
    },
    {
      name: "learnExamView",
      path: "/usr/learn/exam/view/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamView.vue"),
    },
    {
      name: "learnExamForm",
      path: "/usr/learn/exam/form/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamForm.vue"),
    },
    {
      name: "learnNotice",
      path: "/usr/learn/bbs/:enrollNo/:boardSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnBbs.vue"),
    },
    {
      name: "learnNoticeView",
      path: "/usr/learn/bbs/:enrollNo/:boardSeqno/:postsSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnBbsView.vue"),
    },
    {
      name: "learnSurvey",
      path: "/usr/learn/survey/list/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyList.vue"),
    },
    {
      name: "learnSurveyView",
      path: "/usr/learn/survey/view/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyView.vue"),
    },
    {
      name: "learnSurveyForm",
      path: "/usr/learn/survey/form/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyForm.vue"),
    },
    {
      name: "enrollSearch",
      path: "/usr/enroll/search",
      meta: { layout: SubLayout },
      component: () => import("@/views/enroll/EnrollSearchList.vue"),
    },
    {
      name: "bbsList",
      path: "/usr/bbs/:boardSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/Bbs.vue"),
    },
    {
      name: "faqList",
      path: "/usr/bbs/faq/:boardSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/Faq.vue"),
    },
    {
      name: "bbsForm",
      path: "/usr/bbs/:boardSeqno/form",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "bbsView",
      path: "/usr/bbs/:boardSeqno/:postsSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/BbsView.vue"),
    },
    {
      name: "bbsUpdateForm",
      path: "/usr/bbs/:boardSeqno/:postsSeqno/:cmd",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "bbsReplyForm",
      path: "/usr/bbs/:boardSeqno/:postsSeqno/reply",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "myPage",
      path: "/usr/mypage",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPage.vue"),
    },
    {
      name: "myPageInfo",
      path: "/usr/mypage/info",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfo.vue"),
    },
    {
      name: "myPagePwd",
      path: "/usr/mypage/pwd",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfoPwd.vue"),
    },
    {
      name: "myPageLeave",
      path: "/usr/mypage/leave",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfoLeave.vue"),
    },
    {
      name: "compPromoIntro",
      path: "/usr/comp/promo/intro",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoIntro.vue"),
    },
    {
      name: "compPromoList",
      path: "/usr/comp/promo",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoList.vue"),
    },
    {
      name: "compPromoForm",
      path: "/usr/comp/promo/form",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoForm.vue"),
    },
    {
      name: "compPromoRegister",
      path: "/usr/comp/promo/register",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoRegister.vue"),
    },
    {
      name: "compPromoUpdateForm",
      path: "/usr/comp/promo/form/:promoSeqno",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoForm.vue"),
    },
    {
      name: "compPromoView",
      path: "/usr/comp/promo/:promoSeqno",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoView.vue"),
    },
    {
      name: "loginForm",
      path: "/usr/login",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginForm.vue"),
    },
    {
      name: "loginLockForm",
      path: "/usr/login/lock",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginLockForm.vue"),
    },
    {
      name: "loginPwdExpireForm",
      path: "/usr/login/pwdexpire",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginPwdExpireForm.vue"),
    },
    {
      name: "findForm",
      path: "/usr/login/find",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/FindForm.vue"),
    },
    {
      name: "signupTermForm",
      path: "/usr/signup/term",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpTerm.vue"),
    },
    {
      name: "signupForm",
      path: "/usr/signup/form",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpForm.vue"),
    },
    {
      name: "privacyIntro",
      path: "/usr/intro/privacy",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/Privacy.vue"),
    },
    {
      name: "emailPrivacy",
      path: "/usr/intro/emailprivacy",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/EmailPrivacy.vue"),
    },
    {
      name: "legalIntro",
      path: "/usr/intro/legal",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/Legal.vue"),
    },
    {
      path: "*",
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth) && store.getters.currentUser == null) {
    store.dispatch("setSessionScope", { referer: to.path });
    next({ name: "loginForm" });
    // Vue.prototype.$alert("로그인이 필요한 서비스 입니다.<br>로그인 후 이용해 주세요.", "안내", {
    //   confirmButtonText: "확인",
    //   dangerouslyUseHTMLString: true,
    //   callback: (action) => {
    //     next({ name: "loginForm" });
    //   },
    // });
  } else next();
});
router.onError((error) => {
  console.log("router error :", error, navigator.onLine);
  if (/ChunkLoadError/i.test(error) && navigator.onLine) {
    window.location.reload();
  }
});

export default router;
